import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { ContextService } from '@bcef/ia-shared';

import { Agency } from '@core/models/agency.model';
import { ComplaintStore } from '@core/store/complaint.store';

export const agencyResolver: ResolveFn<Agency | null> = () => {
  const store = inject(ComplaintStore);
  const isConnectedUser = inject(ContextService).isConnectedUser;

  return isConnectedUser ? store.getAgency() : null;
};
